window.SEARCH_SCOOTER = window.SEARCH_SCOOTER || {};
window.SEARCH_SCOOTER.config = window.SEARCH_SCOOTER.config || {};
window.SEARCH_SCOOTER.config.radius_miles = document.currentScript.getAttribute('radius-miles') || "";
window.SEARCH_SCOOTER.config.collection_handle = document.currentScript.getAttribute('collection-handle') || "";
window.SEARCH_SCOOTER.config.collection_id = document.currentScript.getAttribute('collection-id') || "";
window.SEARCH_SCOOTER.config.base_url = "https://phpstack-606044-2970735.cloudwaysapps.com/products.php";
window.SEARCH_SCOOTER.config.shopify = {
	STOREFRONT_ACCESS_TOKEN: '55f1b61b12b3d3c63646feb530e75675',
	STOREFRONT_API_URL: `https://${Shopify.shop}/api/2022-10/graphql.json`
};
window.SEARCH_SCOOTER.config.zip_code = window.SEARCH_SCOOTER.config.zip_code || [];

const staticCollectionId = '274372329520'; // check Product Catalog collection

document.addEventListener('DOMContentLoaded', (event) => {
	window.SEARCH_SCOOTER.initSearchScooterButton();
	if (document.getElementById('search-zip-code')) {
		const localStorageSearchZipCode = localStorage?.getItem('search_zipcode') || "";
		document.getElementById('search-zip-code').value = localStorageSearchZipCode;
	}
});

window.SEARCH_SCOOTER.initSearchScooterButton = function () {
	if (document.getElementById('search-scooter')) {
		const searchScooterElement = document.getElementById('search-scooter');
		searchScooterElement?.addEventListener('click', async function (e) {
			let _this = this;
			_this.classList.add('btn--loading'); // add loading class	
			const searchInputZipCodeElement = document.getElementById('search-zip-code') || "";
			if (searchInputZipCodeElement?.value?.length > 0) {
				if (searchInputZipCodeElement?.value?.length == 5) {
					localStorage.setItem('search_zipcode', searchInputZipCodeElement?.value);
					window.SEARCH_SCOOTER.clearCheckedDeliveryZipCodes(); // clear previous checked delivery zip codes
					if(window?.SEARCH_SCOOTER?.config?.collection_id != staticCollectionId) { // Is static collection
						try {
							await fetch(window?.SEARCH_SCOOTER?.config?.base_url, {
								method: "POST",
								body: JSON.stringify({
									action: 'fetch-products',
									shop: Shopify?.shop,
									zip_code: searchInputZipCodeElement?.value,
									radius_miles: window?.SEARCH_SCOOTER?.config?.radius_miles,
									collection_handle: window?.SEARCH_SCOOTER?.config?.collection_handle
								})
							}).then(response => response.json())
								.then(data => {
									if (data?.SUCCESS == 'TRUE') {
										
											window.SEARCH_SCOOTER.config.zip_code = data?.DATA;
											let deliveryZipCodeElements = document.querySelectorAll('[name="filter.p.m.custom.delivery_zipcode"]');
											deliveryZipCodeElements = Array.prototype.slice.call(deliveryZipCodeElements);
											let checkedCounts = 0;
											for (let i = 0; i < deliveryZipCodeElements?.length; i++) {
												const element = deliveryZipCodeElements[i];
												if (window?.SEARCH_SCOOTER?.config?.zip_code.includes(element?.value) && element?.hasAttribute('disabled') == false) {
													element.checked = true;
													checkedCounts++;
												}
											}

											if(checkedCounts > 0){
												if (document.getElementsByClassName('filter-apply')[0]) {
													document.getElementsByClassName('filter-apply')[0].click();
												}
											}else{
												//swal("Oops!", "This zip code not eligible for the closest offers from our best suppliers.", "error");
                                                location.href = "/collections/all-inventory";
											}
										
									} else {
										swal("Oops!", data?.MESSAGE, "error");
										window.SEARCH_SCOOTER.config.zip_code = [];
									}
								}).catch((err) => {
									swal("Oops!", err?.message, "error");
								});
						} catch (error) {
							swal("Oops!", error?.message, "error");
						}
					}else{
						window.location.href = '/collections/all-inventory?filter.v.price.gte=&filter.v.price.lte=&filter.p.m.custom.delivery_zipcode='+searchInputZipCodeElement?.value;
					}
				} else {
					swal("Oops!", "The zip code must be less than or equal to 5.", "warning");
				}
			} else {
				//swal("Oops!", "Pin codes shouldn't be left blank..", "warning");
				window.location.href = '/collections/all-inventory';
				localStorage.setItem('search_zipcode', '');
			}
			_this.classList.remove('btn--loading'); // remove loading class
		});
	}
};
window.SEARCH_SCOOTER.clearCheckedDeliveryZipCodes = function () {
	let deliveryZipCodeElements = document.querySelectorAll('[name="filter.p.m.custom.delivery_zipcode"]');
	deliveryZipCodeElements = Array.prototype.slice.call(deliveryZipCodeElements);
	for (let i = 0; i < deliveryZipCodeElements?.length; i++) {
		const element = deliveryZipCodeElements[i];
		if (element?.checked == true) {
			element.checked = false;
		}
	}
};
window.SEARCH_SCOOTER.inArray = (needle, haystack) => {
	return needle.some(v => haystack.includes(v));
};

['click', 'change'].forEach(evt =>
	document.addEventListener(evt, (evt) => {
		let targetElement = evt.target; // clicked element
		window.SEARCH_SCOOTER.initSearchScooterButton(); // Initialization Search Scooter button whenever event trigger on the page

		if (targetElement.getAttribute('id') != 'search-zip-code') {
			if (document.getElementById('search-zip-code')) {
				const localStorageSearchZipCode = localStorage?.getItem('search_zipcode') || "";
				if (localStorageSearchZipCode?.length>0) {
					document.getElementById('search-zip-code').value = localStorageSearchZipCode;
				}
			}
		}
	}, false)
);
const localStorageSearchZipCode = localStorage?.getItem('search_zipcode') || "";
if (localStorageSearchZipCode?.length>0) {
	const current_collection = localStorage?.getItem('current-collection') || "";	
	document.getElementById('search-zip-code').value = localStorageSearchZipCode;
	// let product_list = document.querySelectorAll('#product-grid li');
	// product_list.forEach((element) => {
	// 	var get_url = $(element).find('.full-unstyled-link').attr('href');
	// 	var split_url = get_url.split('?')[0];
	// 	$(element).find('.full-unstyled-link').attr('href',split_url)
	// });
	
	var current_url = window.location.href;
	if(current_collection != '' && current_collection != 'all-inventory'){
		let newURL = current_url.replace(`${current_collection}?`, `all-inventory?`);
		if (newURL.includes('?')) {
			window.history.pushState({}, '', newURL);
		    location.reload();
		}else{
			localStorage.setItem('search_zipcode', '');
		}
	}
}
